import { render } from "./Dataset.vue?vue&type=template&id=2e112f44&scoped=true"
import script from "./Dataset.vue?vue&type=script&lang=js"
export * from "./Dataset.vue?vue&type=script&lang=js"

import "./Dataset.vue?vue&type=style&index=0&id=2e112f44&scoped=true&lang=css"

import exportComponent from "/builds/Xpansiv/evo/DataPipeline/DataPipeline.Evolve.Web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e112f44"]])

export default __exports__